import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class CardContainerBodyAPI extends ComponentAPI {
}
export { CardContainerBodyAPI, };
//# sourceMappingURL=card-container-body-api.js.map